var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Observable, from, of } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { map, mergeAll, reduce, filter } from 'rxjs/operators';
import { DwCreateService } from './service/create.service';
import { DwReadService } from './service/read.service';
import { DwUpdateService } from './service/update.service';
import { DwDeleteService } from './service/delete.service';
import { DwListService } from './service/list.service';
import { DwMetadataService } from './metadata.service';
import { DwDataTable } from './model/data-table';
import { DELETE, CREATE, DwDataRow } from './model/data-row';
var DwDocument = /** @class */ (function (_super) {
    __extends(DwDocument, _super);
    function DwDocument(createService, readService, updateService, deleteService, listService, metadataService, documentId, resource) {
        var _this = _super.call(this, {}) || this;
        _this.createService = createService;
        _this.readService = readService;
        _this.updateService = updateService;
        _this.deleteService = deleteService;
        _this.listService = listService;
        _this.metadataService = metadataService;
        _this.documentId = documentId;
        _this.resource = resource;
        _this._haveRead = false;
        _this.eventPool = [];
        _this.event$ = from(_this.eventPool);
        return _this;
    }
    Object.defineProperty(DwDocument.prototype, "tables", {
        get: function () {
            return this.controls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DwDocument.prototype, "haveRead", {
        get: function () {
            return this._haveRead;
        },
        enumerable: true,
        configurable: true
    });
    DwDocument.prototype.registerEvent = function (event) {
        this.eventPool.push(event);
    };
    DwDocument.prototype.jsonToTables = function (datas) {
        var tableTemp = {};
        for (var _i = 0, _a = Object.entries(datas); _i < _a.length; _i++) {
            var _b = _a[_i], name_1 = _b[0], table = _b[1];
            if (!this.get(name_1)) {
                this.addControl(name_1, new DwDataTable([]));
            }
            if (!tableTemp[name_1]) {
                tableTemp[name_1] = [];
            }
            for (var _c = 0, table_1 = table; _c < table_1.length; _c++) {
                var row = table_1[_c];
                if (row['child']) {
                    this.jsonToTables(row['child']);
                    delete row.child;
                }
                var dataRow = new DwDataRow(row);
                this.get(name_1).push(dataRow);
                tableTemp[name_1].push(dataRow);
            }
        }
    };
    DwDocument.prototype.parseToDataTable = function (source) {
        for (var _i = 0, _a = Object.entries(source); _i < _a.length; _i++) {
            var _b = _a[_i], name_2 = _b[0], table = _b[1];
            var dataTable = new DwDataTable(table);
            this.addControl(name_2, dataTable);
        }
        return {};
    };
    DwDocument.prototype.reading = function () {
        return this.event$.pipe(filter(function (event) { return ('reading' in event); }), map(function (event) {
            var obs = event.reading();
            return (obs instanceof Observable) ? obs : of(obs);
        }), mergeAll(), reduce(function (acc, val) {
            return acc && val;
        }, true));
    };
    DwDocument.prototype.readed = function (result) {
        this.event$.subscribe(function (event) {
            var obs = true;
            if ('readed' in event) {
                obs = event.readed(result);
            }
        });
    };
    DwDocument.prototype.read = function (oid) {
        var _this = this;
        var reading = this.reading().pipe(map(function (result) {
            if (result) {
                return _this.readService.read(_this.resource, oid);
            }
            else {
                return of();
            }
        }), mergeAll());
        return new Observable(function (observer) {
            reading.subscribe(function (response) {
                if (response.data) {
                    // for (const [name, table] of Object.entries(response.data)) {
                    //   this.addControl(name, new DwDataTable(table));
                    // }
                    _this.jsonToTables(response.data);
                }
                _this._haveRead = true;
                observer.next(_this.controls);
                observer.complete();
                _this.readed(response);
            });
        });
    };
    DwDocument.prototype.saving = function () {
        return this.event$.pipe(filter(function (event) { return ('saving' in event); }), map(function (event) {
            var obs = event.saving();
            return (obs instanceof Observable) ? obs : of(obs);
        }), mergeAll(), reduce(function (acc, val) {
            return acc && val;
        }, true));
    };
    DwDocument.prototype.saved = function (result) {
        if (result === void 0) { result = null; }
        this.event$.subscribe(function (event) {
            var obs = true;
            if ('saved' in event) {
                obs = event.saved(result);
            }
        });
    };
    DwDocument.prototype.save = function () {
        var _this = this;
        this.saving().subscribe();
        var ret;
        if (this.haveRead) {
            ret = this.update();
        }
        else {
            ret = this.create();
        }
        return new Observable(function (observer) {
            ret.subscribe(function (result) {
                observer.next(result);
                observer.complete();
                _this.saved(result);
            });
        });
    };
    DwDocument.prototype.create = function () {
        var tables = this.getRawValue();
        for (var _i = 0, _a = Object.entries(tables); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], table = _b[1];
            for (var _c = 0, _d = table; _c < _d.length; _c++) {
                var row = _d[_c];
                row['$state'] = CREATE;
            }
        }
        return this.createService.create(this.resource, tables);
    };
    DwDocument.prototype.update = function () {
        var tables = this.getRawValue();
        var temp = {};
        for (var _i = 0, _a = Object.entries(tables); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], table = _b[1];
            var tempTable = [];
            for (var _c = 0, _d = table; _c < _d.length; _c++) {
                var row = _d[_c];
                if (row['$state'] !== '') {
                    tempTable.push(row);
                }
            }
            temp[key] = tempTable;
        }
        return this.updateService.update(this.resource, temp);
    };
    DwDocument.prototype.deleting = function () {
        return this.event$.pipe(filter(function (event) { return ('deleting' in event); }), map(function (event) {
            var obs = event.deleting();
            return (obs instanceof Observable) ? obs : of(obs);
        }), mergeAll(), reduce(function (acc, val) {
            return acc && val;
        }, true));
    };
    DwDocument.prototype.deleted = function () {
        this.event$.subscribe(function (event) {
            var obs = true;
            if ('deleted' in event) {
                obs = event.deleted();
            }
        });
    };
    DwDocument.prototype.delete = function (oids) {
        this.deleting().subscribe();
        var tables = this.getRawValue();
        var temp = {};
        for (var _i = 0, _a = Object.entries(tables); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], table = _b[1];
            var tempTable = [];
            for (var _c = 0, _d = table; _c < _d.length; _c++) {
                var row = _d[_c];
                if (row['$state'] === DELETE) {
                    tempTable.push(row);
                }
            }
            temp[key] = tempTable;
        }
        console.log(temp, 'delete tables:');
        this.deleted();
        return this.deleteService.delete(this.resource, oids);
    };
    DwDocument.prototype.list = function (queryInfo) {
        return this.listService.list((this.resource + '/List'), queryInfo);
    };
    return DwDocument;
}(FormGroup));
export { DwDocument };
